module.exports = "/_next/static/images/d851d32e0935b91e5bccd777ecfeb672-mastercard-promo-hero@3x.jpg.webp";